import React from "react";
import BST2Dashboard from "../../components/BST2Dashboard";

const BST2DashboardPage = () => <BST2Dashboard />;

export default BST2DashboardPage;
